import React, { useState, useEffect } from "react";
import { exportTableToPDF } from "./utils/exportPDF";
import { Link } from "react-router-dom";
import axios from "axios";
import Header from "./components/AdminHeader";
import PDFformat from "./Invoice2";

const RequisitionDetailsPO = () => {
  const id = localStorage.getItem("get_kitchen_id_req");

  const [stockItems, setStockItems] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState("");
  const [kitchenId, setKitchenId] = useState(null);
  const [requisitionList, setRequisitionList] = useState([]);
  const [formData, setFormData] = useState({ itemName: "", quantity: "" });
  const today = new Date().toISOString().split("T")[0];

  const [inputGroups, setInputGroups] = useState([
    { item: "", available: 100, quantity: "", date: today, category_item: "" },
  ]);

  const [selectedItemId, setSelectedItemId] = useState(null);
  const [REID, setSelectedREID] = useState("");
  const [REID1, setSelectedREID1] = useState("");
  const [itemDetails, setItemDetails] = useState([]);
  const [itemDetailsview, setItemDetailsview] = useState([]);
  const [stockOptions, setStockOptions] = useState([]);
  const [stockCategory, setCategory] = useState([]);
  const [stockVendor, setvendor] = useState([]);
  const [filterDate, setFilterDate] = useState("");
  const [filterRequisitionDate, setRequisitionDate] = useState("");

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(requisitionList.length / itemsPerPage);
  const paginatedList = requisitionList.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  useEffect(() => {
    // const user = JSON.parse(localStorage.getItem("user"));
    // if (user?.kitchen) {
    //     setKitchenId(user.kitchen);
    axios
      .get(
        `https://ims-backend.indevconsultancy.in/api/kitchen-stock-reports/by-kitchen/${id}/`
      )
      .then((res) => {
        const formatted = res.data.map((item) => ({
          kitchenstock_id: item.kitchenstock_id,
          stock_name: item.stock_name,
          quantity: item.quantity,
          required_quantity: "",
          required_date: "",
        }));
        setStockItems(formatted);
      })
      .catch((err) => console.error("Error fetching kitchen stock:", err));
    // }
  }, []);

  useEffect(() => {
    fetchRequisitionList();
  }, []);

  useEffect(() => {
    axios
      .get("https://ims-backend.indevconsultancy.in/admin-panel/vendor/")
      .then((res) => setvendor(res.data))
      .catch((err) => console.error("Error fetching stock options:", err));
  }, []);

  useEffect(() => {
    axios
      .get("https://ims-backend.indevconsultancy.in/admin-panel/vendor/")
      .then((res) => {
        setVendors(res.data);
      })
      .catch((err) => {
        console.error("Failed to fetch vendors:", err);
      });
  }, []);

  const stocksItem = (id) => {
    axios
      .get("https://ims-backend.indevconsultancy.in/api/stocks/")
      .then((res) => setStockOptions(res.data))
      .catch((err) => console.error("Error fetching stock options:", err));
  };

  useEffect(() => {
    axios
      .get("https://ims-backend.indevconsultancy.in/admin-panel/category/")
      .then((res) => setCategory(res.data))
      .catch((err) => console.error("Error fetching stock options:", err));
  }, []);

  const statusMap = {
    0: "Request",
    1: "Received",
    2: "Delivery ",
    3: "Pending",
    4: "Delete",
  };
  const statusColorMap = {
    0: "secondary",
    1: "success",
    2: "info",
    3: "warning",
    4: "danger",
  };

  const fetchRequisitionItemDetails = async (checkModal, pk) => {
    try {
      const response = await axios.get(
        `https://ims-backend.indevconsultancy.in/api/item-request-list/${pk}/`
      );
      if (response.status === 200 || response.status === 201) {
        const items = response.data?.requisitiondataitem || [];
        if (checkModal === "view") {
          setItemDetailsview(items);
        } else {
          setItemDetails(items);
        }
      } else {
        if (checkModal === "view") {
          setItemDetailsview([]);
        } else {
          setItemDetails([]);
        }
      }
    } catch (error) {
      console.error("Error fetching item details:", error?.message || error);
      if (checkModal === "view") {
        setItemDetailsview([]);
      } else {
        setItemDetails([]);
      }
    }
  };

  // console.log(inputGroups);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://ims-backend.indevconsultancy.in/api/add-request-items",
        {
          items: inputGroups.map((group) => ({
            item: group.item,
            quantity: group.quantity,
            kitchenId: kitchenId,
            available: "",
            date: group.date,
            category: group.category_item,
          })),
        }
      );

      if (response.status === 200 || response.status === 201) {
        setInputGroups([{ item: "", available: 100, quantity: "", date: "" }]);
        // document.getElementById('registerModalClose')?.click();
        fetchRequisitionList();
      } else {
        alert("Failed to save items");
      }
    } catch (error) {
      console.error("API error:", error);
      alert("An error occurred while saving data");
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (filterRequisitionDate || filterDate) {
      fetchRequisitionList(filterRequisitionDate, filterDate);
    } else {
      fetchRequisitionList();
    }
  };

  const addInputGroup = () => {
    setInputGroups([
      ...inputGroups,
      {
        item: "",
        available: 100,
        quantity: "",
        date: today,
        category_item: "",
      },
    ]);
  };
  const removeInputGroup = (index) => {
    const updated = [...inputGroups];
    updated.splice(index, 1);
    setInputGroups(updated);
  };

  const handleInputChange = (index, field, value) => {
    const updated = [...inputGroups];
    updated[index][field] = value;
    stocksItem(value);
    setInputGroups(updated);
  };

  const [valuExport, setExport] = useState([]);
  const fetchRequisitionList = (date = "", status = "") => {
    let url = `https://ims-backend.indevconsultancy.in/api/requistion-list/?kitchen_id=${id}`;
    const params = [];
    if (date) params.push(`date=${encodeURIComponent(date)}`);
    if (status) params.push(`status=${encodeURIComponent(status)}`);

    if (params.length > 0) {
      url += `&${params.join("&")}`;
    }
    axios
      .get(url)
      .then((response) => {
        if (response.data.requisitiondata) {
          setRequisitionList(response.data.requisitiondata);
          setExport(response.data.requisitiondata);
          setCurrentPage(1);
        }
      })
      .catch((error) =>
        console.error("Failed to fetch requisition list:", error)
      );
  };

  const [itemDetailsSaveData, setItemDetailsSaveData] = useState([]);
  const [selectedVendorId, setSelectedVendorId] = useState("");
  const [selectedDateofReceived, setSelectedDateofReceived] = useState("");

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setSelectedDateofReceived(today);
  }, []);
  const handleInputChangeMRN = (index, field, value) => {
    const updatedDetails = [...itemDetails];
    updatedDetails[index][field] = value;
    setItemDetailsSaveData(updatedDetails);
  };

  const handleSubmitMRN = async () => {
    try {
      const payload = {
        requisition_id: REID1,
        date_of_order: selectedDateofReceived,
        vendor_id: selectedVendorId,
        items: itemDetailsSaveData,
      };
      const response = await axios.post(
        "https://ims-backend.indevconsultancy.in/api/sumit-request-items",
        payload
      );
      addInputGroup();
      fetchRequisitionList();
    } catch (error) {
      console.error("Submission failed:", error);
      alert("Error submitting requisition");
    }
  };

  const handlePOClick = (poNumber) => {
    localStorage.setItem("selectedPO", poNumber);
    alert(`Stored PO in localStorage: ${poNumber}`);
  };

  const handleItemlick = (poNumber) => {
    localStorage.setItem("selectedItem", poNumber);
    alert(`Stored PO in localStorage: ${poNumber}`);
  };

  const [purchaseData, setPurchaseData] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmitExport = async (id, reqid, kitchen_name) => {
    try {
      if (!id || typeof id !== "string") throw new Error("Invalid ID");

      // Remove only "P00" from the start of the string
      const output = id.replace(/^POO/, "");

      const response = await axios.get(
        `https://ims-backend.indevconsultancy.in/api/purchaseitmetilstwise/?purchase_id=${output}`
      );
      // const response = await axios.get(`https://mne.agrotutor.co/apinew/download_survey_list2.php?reqid=${reqid}&purchaseid=${output}&kitchen_name=${kitchen_name}`);
      console.log("dsfdsd", response.data);
      setPurchaseData(response.data);
      setError(null);
    } catch (err) {
      setError("Error fetching purchase details");
      console.error(err);
    }
  };

  console.log("ada", itemDetails);
  const exportToCSV = () => {
    if (!valuExport.length) return;

    const headers = [
      "S.No.",
      "Requisition ID",
      "Kitchen Name",
      "Purchase Order(s)",
      "Date",
      "Status",
    ];

    const rows = valuExport.map((item, index) => [
      index + 1,
      `RE00${item.reqid}`,
      item.kitchen_name,
      item.purchaseorderid?.join(", "),
      new Date(item.requestdate).toLocaleDateString(),
      statusMap[item.status] || "Unknown",
    ]);

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers.join(","), ...rows.map((r) => r.join(","))].join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "requisition_list.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const exportToPDF = () => {
    if (!valuExport.length) return alert("No data to export.");
    const headers = ["S.No.", "Requisition ID", "Kitchen Name", "Purchase Order(s)", "Date", "Status"];
    const rows = valuExport.map((item, index) => [
      index + 1,
      `RE00${item.reqid}`,
      item.kitchen_name,
      item.purchaseorderid?.join(", "),
      new Date(item.requestdate).toLocaleDateString(),
      statusMap[item.status] || "Unknown",
    ]);
    exportTableToPDF({ title: "Requisition PO List", headers, rows, filename: "requisition_list.pdf", filterInfo: `Total: ${rows.length}` });
  };

  return (
    <>
      <Header />
      <div className="container-fluid px-2">
        <div className="content">
          <div className="container-fluid">
            {/* <div className="row">
                            <div className="col">
                                <span className="fs-1">Requisition List</span>
                            </div>
                            <div className="col">
                                <nav aria-label="breadcrumb" className="py-2">
                                    <ol className="breadcrumb justify-content-end">
                                        <li className="breadcrumb-item active" aria-current="page">Requisition List</li>
                                        <li className="breadcrumb-item"><Link to="/mobilehome">Home</Link></li>
                                    </ol>
                                </nav>
                            </div>
                        </div> */}
            <div className="row align-items-center justify-content-between py-2">
              <div className="col-md-6 col-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb justify-content-start mb-0">
                    <li className="breadcrumb-item">
                      <Link to="/dashboard">Home</Link>
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="col-md-6 col-6 text-end">
                <span className="fs-1">Requisition List</span>
              </div>
            </div>

            <div className="row g-3">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header border-info">
                    <form onSubmit={handleSearch}>
                      <div className="row g-3">
                        <div className="col-lg">
                          <select
                            className="form-control"
                            value={selectedVendor}
                            onChange={(e) => setSelectedVendor(e.target.value)}
                          >
                            <option value="">Select Vendor</option>
                            {vendors
                              .filter((vendor) => vendor.status === 1) // Optional: show only active vendors
                              .map((vendor) => (
                                <option
                                  key={vendor.vendor_id}
                                  value={vendor.vendor_id}
                                >
                                  {vendor.vendor_name.trim()}
                                </option>
                              ))}
                          </select>
                        </div>
                        <div className="col-lg">
                          <select
                            className="form-control"
                            value={filterDate}
                            onChange={(e) => setFilterDate(e.target.value)}
                          >
                            <option value="">Select Status</option>
                            <option value="0">Pending</option>
                            <option value="1">Received</option>
                            <option value="2">Delivery</option>
                            <option value="4">Delete</option>
                          </select>
                        </div>
                        <div className="col-lg">
                          <input
                            type="date"
                            className="form-control"
                            value={filterRequisitionDate}
                            onChange={(e) => setRequisitionDate(e.target.value)}
                          />
                        </div>

                        <div className="col-lg-2">
                          <button
                            type="submit"
                            className="btn btn-primary w-100"
                          >
                            Search
                          </button>
                        </div>
                        <div className="col-lg-1">
                          <button
                            type="button"
                            className="btn btn-outline-dark w-100"
                            onClick={() => {
                              setFilterDate("");
                              fetchRequisitionList();
                            }}
                          >
                            Reset
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>

                  <div className="card-body">
                    <div className="row g-0 align-items-center">
                      <div className="d-flex justify-content-between">
                        <h6 className="fw-bold mb-0">
                          Total Requisition(s):{" "}
                          <span>{requisitionList.length}</span>
                        </h6>
                        <div>
                          <button className="btn btn-primary btn-sm mb-1 me-1" onClick={exportToCSV}>
                            <i className="fas fa-file-csv me-1"></i> Export CSV
                          </button>
                          <button className="btn btn-danger btn-sm mb-1" onClick={exportToPDF}>
                            <i className="fas fa-file-pdf me-1"></i> Export PDF
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="table-responsive scrollbar">
                      <table className="table text-center table-bordered table-striped fs--1 mb-0">
                        <thead className="bg-primary text-white">
                          <tr>
                            {/*<th>S.No.</th>*/}
                            <th>Requisition ID</th>
                            <th>Kitchen Name</th>
                            {/* <th>Purchase No</th> */}
                            <th>Date</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paginatedList.length === 0 ? (
                            <tr>
                              <td colSpan="5">Loading or no data available</td>
                            </tr>
                          ) : (
                            paginatedList.map((item, index) => {
                              return (
                                <tr key={item.reqid}>
                                  <td>RE00{item.reqid || item.reqid}</td>
                                  <td>{item.kitchen_name}</td>

                                  {/* <td style={{ width: "300px" }}>
                                    {item.purchaseorderid.map((po, index) => (
                                      <button
                                        key={index}
                                        data-bs-toggle="modal"
                                        data-bs-target="#exportData"
                                        className="btn btn-primary add-item btn-sm"
                                        onClick={() =>
                                          handleSubmitExport(
                                            po,
                                            item.reqid,
                                            item.kitchen_name
                                          )
                                        }
                                      >
                                        {po}
                                      </button>
                                    ))}
                                  </td> */}
                                  <td>
                                    {new Date(
                                      item.requestdate
                                    ).toLocaleDateString()}
                                  </td>
                                  <td>
                                    <span
                                      className={`badge bg-${statusColorMap[item.status] || "dark"
                                        }`}
                                    >
                                      {statusMap[item.status] || "Unknown"}
                                    </span>
                                  </td>
                                  <td>
                                    {item.status != "4" && (

                                      <div className="d-flex gap-2 justify-content-center">
                                        <button
                                          className="btn btn-primary add-item btn-sm"
                                          type="button"
                                          data-bs-toggle="modal"
                                          data-bs-target="#viweModal"
                                          onClick={() => {
                                            setSelectedItemId(item.reqid);
                                            fetchRequisitionItemDetails(
                                              "view",
                                              item.reqid
                                            );
                                          }}
                                          title="View"
                                        >
                                          <i className="fas fa-eye"></i>
                                        </button>
                                        {item.status == "0" && (
                                          <button
                                            className="btn btn-primary add-item btn-sm"
                                            type="button"
                                            data-bs-toggle="modal"
                                            data-bs-target="#editModal"
                                            onClick={() => {
                                              setSelectedREID(
                                                "RE00" + item.reqid
                                              );
                                              setSelectedREID1(item.reqid);
                                              setSelectedItemId(item.reqid);
                                              fetchRequisitionItemDetails(
                                                "edit",
                                                item.reqid
                                              );
                                            }}
                                            title="Edit"
                                          >
                                            Received
                                          </button>
                                        )}
                                      </div>
                                    )}

                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>

                    {/* Pagination Controls */}
                    {/* {paginatedList.length > 10 && ( */}
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <button
                        className="btn btn-outline-primary btn-sm"
                        onClick={() =>
                          setCurrentPage((prev) => Math.max(prev - 1, 1))
                        }
                        disabled={currentPage === 1}
                      >
                        Previous
                      </button>
                      <span>
                        Page {currentPage} of {totalPages}
                      </span>
                      <button
                        className="btn btn-outline-primary btn-sm"
                        onClick={() =>
                          setCurrentPage((prev) =>
                            Math.min(prev + 1, totalPages)
                          )
                        }
                        disabled={currentPage === totalPages}
                      >
                        Next
                      </button>
                    </div>
                    {/* )} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="registerModal"
          tabIndex="-1"
          aria-labelledby="registerModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <form onSubmit={handleSubmit}>
                <div className="modal-header">
                  <h5 className="modal-title" id="registerModalLabel">
                    Add Requisition Item
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>

                <div className="modal-body">
                  {inputGroups.map((group, index) => (
                    <div className="input-group mb-3" key={index}>
                      <select
                        className="form-control"
                        name="category_item[]"
                        value={group.category_item}
                        onChange={(e) =>
                          handleInputChange(
                            index,
                            "category_item",
                            e.target.value
                          )
                        }
                      >
                        <option value="">Select Category</option>
                        {stockCategory.map((categoty) => (
                          <option
                            key={categoty.category_id}
                            value={categoty.category_id}
                          >
                            {categoty.category_name}
                          </option>
                        ))}
                      </select>
                      <select
                        className="form-control"
                        name="item[]"
                        value={group.item}
                        onChange={(e) =>
                          handleInputChange(index, "item", e.target.value)
                        }
                      >
                        <option value="">Select Item</option>
                        {stockOptions.map((stock) => (
                          <option key={stock.stock_id} value={stock.stock_id}>
                            {stock.stock_name} ({stock.units})
                          </option>
                        ))}
                      </select>

                      <span className="input-group-text">Quantity</span>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Quantity"
                        value={group.quantity}
                        onChange={(e) =>
                          handleInputChange(index, "quantity", e.target.value)
                        }
                      />

                      <span className="input-group-text">Date</span>
                      <input
                        type="date"
                        className="form-control"
                        value={
                          group.date || new Date().toISOString().split("T")[0]
                        }
                        onChange={(e) =>
                          handleInputChange(index, "date", e.target.value)
                        }
                      />

                      {index == 0 && (
                        <button
                          className="btn btn-success"
                          type="button"
                          onClick={addInputGroup}
                        >
                          <i className="fas fa-plus"></i>
                        </button>
                      )}

                      {index > 0 && (
                        <button
                          className="btn btn-danger"
                          type="button"
                          onClick={() => removeInputGroup(index)}
                        >
                          <i className="fas fa-minus"></i>
                        </button>
                      )}
                    </div>
                  ))}
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    data-bs-dismiss="modal"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="exportData"
          tabIndex="-1"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-scrollable modal-xl modal-fullscreen-sm-down">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Export Data</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              {purchaseData && (
                <div className="modal-body overflow-auto">
                  <div className="table-responsive">
                    <PDFformat data={purchaseData} />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="editModal"
          tabIndex="-1"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Add Material Received Note (MRN)
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                {itemDetails.length === 0 ? (
                  <p>No items available</p>
                ) : (
                  <>
                    <div className="row">
                      <div className="col-md-4">
                        <span className="input-group-text">
                          Requisition ID: {REID}
                        </span>
                      </div>
                    </div>

                    <div className="input-group mb-3 mt-3">
                      <span className="input-group-text">Date of Received</span>
                      <input
                        type="date"
                        className="form-control"
                        value={selectedDateofReceived}
                        onChange={(e) =>
                          setSelectedDateofReceived(e.target.value)
                        }
                      />
                    </div>
                    <div class="table-responsive">
                      <table className="table text-center table-bordered table-striped fs--1 mb-0">
                        <thead className="bg-primary text-white">
                          <tr>
                            <th>Category Name</th>
                            {/* <th>Vendor Name</th> */}
                            <th>Item Name</th>
                            <th>Required Quantity</th>
                            <th>Vendor Name</th>
                            <th>Receive Quantity</th>
                            <th>Remarks </th>
                          </tr>
                        </thead>
                        <tbody>
                          {itemDetails.map((detail, index) => (
                            <tr key={index}>
                              <td>{detail.category_name}</td>
                              {/* <td>{detail.vendor_name}</td> */}
                              <td>{detail.stock}</td>
                              <td>{detail.requestquantity}</td>

                              <td>
                                <select
                                  className="form-control"
                                  style={{
                                    minWidth:
                                      window.innerWidth <= 576
                                        ? "200px"
                                        : "auto",
                                  }}
                                  name="vendor_id[]"
                                  value={detail.vendor_id}
                                  onChange={(e) => {
                                    handleInputChangeMRN(
                                      index,
                                      "vendor_id",
                                      e.target.value
                                    );
                                    handleInputChangeMRN(
                                      index,
                                      "price",
                                      "PO00" +
                                      Math.floor(1000 + Math.random() * 9000)
                                    );
                                  }}
                                >
                                  <option value="">Select Vendor</option>
                                  {stockVendor.map((stock) => (
                                    <option
                                      key={stock.vendor_id}
                                      value={stock.vendor_id}
                                    >
                                      {stock.vendor_name}
                                    </option>
                                  ))}
                                </select>
                              </td>

                              <td>
                                <input
                                  type="number"
                                  className="form-control"
                                  style={{
                                    minWidth:
                                      window.innerWidth <= 576
                                        ? "150px"
                                        : "auto",
                                  }}
                                  // placeholder="Received Qty"
                                  value={detail.receivedquantity}
                                  onChange={(e) =>
                                    handleInputChangeMRN(
                                      index,
                                      "receivedquantity",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>

                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  style={{
                                    minWidth:
                                      window.innerWidth <= 576
                                        ? "150px"
                                        : "auto",
                                  }}
                                  // placeholder="remarks"
                                  value={detail.remarks}
                                  onChange={(e) =>
                                    handleInputChangeMRN(
                                      index,
                                      "remarks",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  data-bs-dismiss="modal"
                  onClick={handleSubmitMRN}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="viweModal"
          tabIndex="-1"
          aria-labelledby="registerModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-xl modal-dialog-scrollable">
            <div className="modal-content">
              <form onSubmit={handleSubmit}>
                <div className="modal-header">
                  <h5 className="modal-title" id="registerModalLabel">
                    View
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>

                <div className="modal-body py-2">
                  {itemDetailsview.length === 0 ? (
                    <p className="text-center text-danger">No data found</p>
                  ) : (
                    <div
                      className="table-responsive"
                      style={{ height: "399px" }}
                    >
                      <table className="table text-center table-bordered table-striped fs--1 mb-0">
                        <thead className="bg-primary text-white">
                          <tr>
                            <th>S.No.</th>
                            <th>Category Name</th>
                            <th>Vendor Name</th>
                            <th>Item</th>
                            <th>Requested Quantity</th>
                            <th>Requested Date</th>
                            <th>Received Quantity</th>
                            <th>Received Date</th>
                            <th>Pending Quantity</th>
                          </tr>
                        </thead>
                        <tbody>
                          {itemDetailsview.map((item, index) => (
                            <tr key={item.id}>
                              <td>{index + 1}</td>
                              <td>{item.category_name}</td>
                              <td>{item.vendor_name}</td>
                              <td>{item.stock}</td>
                              <td>{item.requestquantity}</td>
                              <td>
                                {new Date(
                                  item.required_date
                                ).toLocaleDateString()}
                              </td>
                              <td>{item.recievedquantity}</td>
                              <td>
                                {item.recievedquantity > 0 && item.recieve_date
                                  ? new Date(
                                    item.recieve_date
                                  ).toLocaleDateString()
                                  : ""}
                              </td>
                              <td
                                style={{
                                  color:
                                    item.pendingquantity > 0 ? "red" : "green",
                                  fontWeight: "bold",
                                  backgroundColor:
                                    item.pendingquantity > 0
                                      ? "#ffe5e5"
                                      : "#e6ffe6",
                                }}
                              >
                                {item.pendingquantity > 0
                                  ? `Quantity pending (${item.pendingquantity})`
                                  : "No Pending"}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default RequisitionDetailsPO;
